module.exports = __webpack_public_path__ + "static/media/dashboard_icon_black.bc5e987c.svg";